import {
    SEARCH_DEFAULT_QUERY,
    SEARCH_DEFAULT_QUERY_ERROR,
    SEARCH_DEFAULT_QUERY_SUCCESS,
} from "core-web/state/models/Search/constants";

import getQueryParams from "core-web/utils/getQueryParams";
import store from "core-web/state/store";

export const queryDefault = (location) => (dispatch) => {
    dispatch({ type: SEARCH_DEFAULT_QUERY });
    try {
        const params = getQueryParams(location);
        let query = params.q || "";

        if (query) {
            query = encodeURI(query);
            try {
                query = decodeURI(query);
            } catch (e) {
                console.error(e, "Failed decode in dispatch");
            }
        } else {
            delete params.q;
        }

        dispatch({
            type: SEARCH_DEFAULT_QUERY_SUCCESS,
            query,
        });
    } catch (e) {
        dispatch({ type: SEARCH_DEFAULT_QUERY_ERROR });
        throw e;
    }
};

export default (location, currentStore = store) => currentStore.dispatch(queryDefault(location));
